import React, {useMemo} from 'react';
import {useSequentialModalContext} from '@/components/basic/sequential-modal/context';
import {toPriceStr} from '@/utils';

export const EXCHANGE_REWARD_SUCCESS = 'EXCHANGE_REWARD_SUCCESS';

type ExchangeRewardSuccessProps = {
  totalAmount?: number | string;
};

export default function ExchangeRewardSuccess(
  props: ExchangeRewardSuccessProps,
) {
  const {goToNext} = useSequentialModalContext();
  const {totalAmount = 0} = props;
  const finalAmount = useMemo(() => Number(totalAmount) || 0, [totalAmount]);

  return (
    <div className="w-[19rem] rounded-2xl bg-[#1b1b1f] border border-[#45454d] p-5 text-white">
      <div className="text-center text-xl font-bold">Reward Claimed</div>
      <div className="mt-2 text-center text-sm text-[#c6c8cf]">
        The bonus is automatically claimed after entering the page.
      </div>
      <div className="mt-4 rounded-xl bg-[#26262c] p-4">
        <div className="text-xs text-[#9ca3af]">Total Amount</div>
        <div className="mt-1 text-3xl font-extrabold text-[#fde047]">
          {toPriceStr(finalAmount, {fixed: 0, round: 'floor'})}
        </div>
      </div>
      <div
        className="mt-5 h-11 rounded-xl bg-[#f59e0b] text-[#111827] font-bold text-center leading-[2.75rem] cursor-pointer"
        onClick={goToNext}>
        OK
      </div>
    </div>
  );
}
